import {
  LENGS_LIST,
  LENGS_FILTER,
  LENGS_CREATE,
  LENGS_CREATE_SUCCESS,
  LENGS_LIST_SUCCESS,
  LENGS_REQUEST_FAILED,
  LENGS_UPDATE,
  LENGS_UPDATE_SUCCESS,
} from "../../store/lengs/actionTypes";

const initialState = {
  lengs: [],
  lengsCreated: {},
  lengsUpdated: {},
  loading: false,
  error: "",
};

const lengs = (state = initialState, action) => {
  switch (action.type) {
    case LENGS_CREATE:
      state = {
        ...state,
        loading: true,
      };
      break;
    case LENGS_LIST:
      state = {
        ...state,
        loading: true,
      };
      break;
    case LENGS_FILTER:
      state = {
        ...state,
        loading: true,
      };
      break;
    case LENGS_UPDATE:
      state = {
        ...state,
        loading: true,
      };
      break;
    case LENGS_CREATE_SUCCESS:
      state = {
        ...state,
        loading: false,
        lengsCreated: action.payload,
        error: "",
      };
      break;
    case LENGS_LIST_SUCCESS:
      state = {
        ...state,
        loading: false,
        lengs: action.payload,
        lengsCreated: {},
        lengsUpdated: {},
        error: "",
      };
      break;
    case LENGS_UPDATE_SUCCESS:
      state = {
        ...state,
        loading: false,
        lengsUpdated: action.payload,
        error: "",
      };
      break;
    case LENGS_REQUEST_FAILED:
      state = {
        ...state,
        loading: false,
        error: action.payload,
      };
      break;
    default:
      state = { ...state };
      break;
  }
  return state;
};

export default lengs;
